module.exports = __webpack_public_path__ + "static/media/card-back.20c920a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/card-back.svg
// module id = 87
// module chunks = 0